import React from "react";
import Lottie from "react-lottie";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ButtonArrow from "../ui/ButtonArrow";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardHeader from "@mui/material/CardHeader";

import CallToAction from "../ui/CallToAction";

import animationData from "../../animations/landinganimation/data";
import revolutionBackground from "../../assets/repeatingBackground.svg";
import infoBackground from "../../assets/infoBackground.svg";
import Welcome from "../../assets/welcome.JPG";
import Team2 from "../../assets/team-2.JPG";
import Team3 from "../../assets/team-3.JPG";
import HeartRateMonitoring from "../../assets/Heart_Rate_Monitoring.jpg";
import Graphene from "../../assets/Graphene.jpg";
import EVStation from "../../assets/EV_Charging_Stattion.jpg";
import Carousel from "react-material-ui-carousel";

const projects = [
  
  {
    title: "Secure Ecofriendly Housing",
    image: "https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554798/Pivot%20Club/Ecofriendly_ozx80t.jpg",
    description:
      "Creating a sustainable future through Ecofriendly housing units",
  },
  {
    title: "Hostel Security Management System",
    image: "https://res.cloudinary.com/pivot-club-ku/image/upload/v1662554802/Pivot%20Club/Hostel-Security_naxj2x.jpg",
    description: "Creating a secure environment for fellow comrades to cohabitate in. Top notch security for a hostel based setup!",
  },
  {
    title: "Heart Rate Monitoring System",
    image:
      "https://res.cloudinary.com/pivot-club-ku/image/upload/v1662526986/Pivot%20Club/Heart_Rate_Monitoring_ttudgc.jpg",
    description:
      "Built an IoT Heart Rate Monitoring System that measures an individual heartbeat per minute and uploads the data ThingSpeakk, an IoT cloud provider. The data is analysed and data is sent to the individual every fortnight through email.",
  },
];

const researchpapers = [
  {
    title: "A focus on EV Charging Stattions",
    image:
      "https://res.cloudinary.com/pivot-club-ku/image/upload/v1662526987/Pivot%20Club/EV_Charging_Stattion_qvmg1t.jpg",
    description:
      "With the rise of electric vehicles, we are focusing on EV charging stations",
  },
  {
    title: "Graphene",
    image:
      "https://res.cloudinary.com/pivot-club-ku/image/upload/v1662527014/Pivot%20Club/Graphene_qvi8hk.jpg",
    description:
      "Graphene is a material that is 200 times stronger than steel and 100 times lighter than aluminium. It is also a good conductor of electricity and heat. It is a wonder material that can be used in a variety of applications. We are focusing on using graphene in the field of medicine and healthcare, aerospace industry, power and energy and construction industry.",
  },
];

const techflames = [
  {
    title: "A focus on EV Charging Stattions",
    image:
      "https://res.cloudinary.com/pivot-club-ku/image/upload/v1662526987/Pivot%20Club/EV_Charging_Stattion_qvmg1t.jpg",
    description:
      "With the rise of electric vehicles, we are focusing on EV charging stations",
  },
  {
    title: "Graphene",
    image:
      "https://res.cloudinary.com/pivot-club-ku/image/upload/v1662527014/Pivot%20Club/Graphene_qvi8hk.jpg",
    description:
      "Graphene is a material that is 200 times stronger than steel and 100 times lighter than aluminium. It is also a good conductor of electricity and heat. It is a wonder material that can be used in a variety of applications. We are focusing on using graphene in the field of medicine and healthcare, aerospace industry, power and energy and construction industry.",
  },
];

const useStyles = makeStyles((theme) => ({
  animation: {
    maxWidth: "50em",
    minWidth: "21em",
    marginTop: "2em",
    marginLeft: "10%",
    [theme.breakpoints.down("md")]: {
      maxWidth: "20em",
    },
  },
  estimateButton: {
    ...theme.typography.estimate,
    backgroundColor: theme.palette.common.orange,
    borderRadius: 50,
    height: 45,
    width: 145,
    marginRight: 40,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  buttonContainer: {
    marginTop: "1em",
  },
  learnButtonHero: {
    ...theme.typography.learnButton,
    fontSize: "0.9rem",
    height: 45,
    width: 145,
  },
  learnButton: {
    ...theme.typography.learnButton,
    fontSize: "0.7rem",
    height: 35,
    padding: 5,
    [theme.breakpoints.down("md")]: {
      marginBottom: "2em",
    },
  },
  mainContainer: {
    marginTop: "5em",
    [theme.breakpoints.down("lg")]: {
      marginTop: "3em",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "2em",
    },
  },
  heroTextContainer: {
    minWidth: "21.5em",
    marginLeft: "1em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  specialText: {
    fontFamily: "Pacifico",
    color: theme.palette.common.orange,
  },
  subtitle: {
    marginBottom: "1em",
  },
  icon: {
    marginLeft: "2em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  serviceContainer: {
    marginTop: "4em",
    [theme.breakpoints.down("md")]: {
      padding: 20,
    },
    padding: 10,
  },
  revolutionBackground: {
    backgroundImage: `url(${revolutionBackground})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "100%",
    width: "100%",
  },
  revolutionCard: {
    position: "relative",
    boxShadow: theme.shadows[10],
    borderRadius: 15,
    padding: "10em",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      paddingTop: "8em",
      paddingBottom: "8em",
      paddingLeft: 0,
      paddingRight: 0,
      borderRadius: 0,
      width: "100%",
    },
  },
  infoBackground: {
    backgroundImage: `url(${infoBackground})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "100%",
    width: "100%",
  },
  rowContainer: {
    paddingLeft: "5em",
    paddingRight: "5em",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "1.5em",
      paddingRight: "1.5em",
    },
  },
}));

export default function LandingPage(props) {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("md"));
  const matchesXS = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesMD = useMediaQuery(theme.breakpoints.down("lg"));

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid container direction="column" className={classes.mainContainer}>
      <Grid item>
        {/*-----Hero Block-----*/}
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          direction="row"
        >
          <Grid sm item className={classes.heroTextContainer}>
            <Typography variant="h2" align="center">
              Epitome of Engineering
              <br />
              and Technology
            </Typography>
            <Grid
              container
              justifyContent="center"
              className={classes.buttonContainer}
            >
              <Grid item>
                <Button
                  component={Link}
                  to="/register"
                  className={classes.estimateButton}
                  variant="contained"
                  onClick={() => props.setValue(5)}
                >
                  Join Us
                </Button>
              </Grid>
              <Grid item>
                <Button
                  component={Link}
                  to="/teams"
                  className={classes.learnButtonHero}
                  variant="outlined"
                  onClick={() => props.setValue(2)}
                >
                  <span style={{ marginRight: 10 }}>Learn More</span>
                  <ButtonArrow
                    width={15}
                    height={15}
                    fill={theme.palette.common.blue}
                  />
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid sm item className={classes.animation}>
            <Lottie options={defaultOptions} height={"100%"} width={"100%"} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {" "}
        {/*-----Welcome to our Club-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : undefined}
          className={classes.serviceContainer}
        >
          <Grid
            item
            style={{
              marginLeft: matchesSM ? 0 : "5em",
              textAlign: matchesSM ? "center" : undefined,
            }}
          >
            <Typography variant="h4">Welcome to The Pivot Club KU</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Comprises of students and experts from the various
              <br></br>
              technical fields who collaborate and come up with solutions to
              <br></br>
              technical problems facing the society.
            </Typography>
            <Typography variant="subtitle1">
              We build projects from design to{" "}
              <span className={classes.specialText}>prototyping.</span>
            </Typography>
            <Button
              component={Link}
              to="/projects"
              variant="outlined"
              className={classes.learnButton}
              onClick={() => {
                props.setValue(1);
                props.setSelectedIndex(1);
              }}
            >
              <span style={{ marginRight: 10 }}>Learn More</span>
              <ButtonArrow
                width={10}
                height={10}
                fill={theme.palette.common.blue}
              />
            </Button>
          </Grid>
          <Grid item lg>
            <img
              src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1663515267/Pivot%20Club/welcome_hpry4n.jpg"
              alt="Welcome"
              style={{
                maxWidth: matchesSM ? "25em" : "40em",
                marginRight: matchesMD ? 0 : "5em",
                marginBottom: matchesMD ? 0 : 0,
                padding: "0.5em",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {" "}
        {/*-----Our Mission-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : "flex-end"}
          className={classes.serviceContainer}
        >
          <Grid
            item
            style={{
              textAlign: matchesSM ? "center" : undefined,
            }}
          >
            <Typography variant="h4">Our Mission & Vision</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Provide solutions to the existing challenges
              <br></br>
              facing the technical field through research and innovation.
            </Typography>
          </Grid>
          <Grid item lg>
            <img
              src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1662527043/Pivot%20Club/team-3_ftwcyh.jpg"
              alt="Driven by Engineering"
              style={{
                maxWidth: matchesSM ? "25em" : "40em",
                marginRight: matchesMD ? 0 : "5em",
                marginBottom: matchesMD ? 0 : 0,
                padding: "0.5em",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {" "}
        {/*-----Our Core Values & Benefits-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : undefined}
          className={classes.serviceContainer}
        >
          <Grid
            item
            style={{
              marginLeft: matchesSM ? 0 : "5em",
              textAlign: matchesSM ? "center" : undefined,
            }}
          >
            <Typography variant="h4">Our Core Values & Benefits</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Our core values include: teamwork, hardwork, commitment,
              <br></br>
              integrity and discipline.
              <br></br>
            </Typography>
            <Typography variant="subtitle1">
              We build projects from design to{" "}
              <span className={classes.specialText}>prototyping.</span>
            </Typography>
          </Grid>
          <Grid item lg>
            <img
              src="https://res.cloudinary.com/pivot-club-ku/image/upload/v1663515263/Pivot%20Club/team-2_idw7gi.jpg"
              alt="Core Values & Benefits"
              style={{
                maxWidth: matchesSM ? "25em" : "40em",
                marginRight: matchesMD ? 0 : "5em",
                marginBottom: matchesMD ? 0 : 0,
                padding: "0.5em",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {/*-----Notable Projects-----*/}
        <Grid
          container
          style={{ height: "60em" }}
          alignItems="center"
          justifyContent="center"
        >
          <Card className={classes.revolutionCard}>
            <CardContent>
              <Grid
                container
                direction="column"
                style={{ textAlign: "center" }}
              >
                <Grid item>
                  <Typography variant="h3" gutterBottom>
                    Projects
                  </Typography>
                </Grid>
                <Grid item>
                  <Carousel>
                    {projects.map((project, i) => (
                      <Card sx={{ maxWidth: 480 }}>
                        <CardHeader title={project.title} />
                        <CardMedia
                          component="img"
                          height="194"
                          width="194"
                          image={project.image}
                          alt={project.title}
                        />
                        <CardContent>
                          <Typography variant="body2" color="text.secondary">
                            {project.description}
                          </Typography>
                        </CardContent>
                        <Button
                          component={Link}
                          to="/projects"
                          variant="outlined"
                          className={classes.learnButton}
                          onClick={() => {
                            props.setValue(1);
                            props.setSelectedIndex(1);
                          }}
                        >
                          <span style={{ marginRight: 10 }}>Learn More</span>
                          <ButtonArrow
                            width={10}
                            height={10}
                            fill={theme.palette.common.blue}
                          />
                        </Button>
                      </Card>
                    ))}
                  </Carousel>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid item>
        {/*-----Notable ResearchPapers-----*/}
        <Grid
          container
          style={{ height: "60em" }}
          alignItems="center"
          justifyContent="center"
        >
          <Card className={classes.revolutionCard}>
            <CardContent>
              <Grid
                container
                direction="column"
                style={{ textAlign: "center" }}
              >
                <Grid item>
                  <Typography variant="h3" gutterBottom>
                    Research Papers
                  </Typography>
                </Grid>
                <Grid item>
                  <Carousel>
                    {researchpapers.map((project, i) => (
                      <Card sx={{ maxWidth: 480 }}>
                        <CardHeader title={project.title} />
                        <CardMedia
                          component="img"
                          height="194"
                          width="194"
                          image={project.image}
                          alt={project.title}
                        />
                        <CardContent>
                          <Typography variant="body2" color="text.secondary">
                            {project.description}
                          </Typography>
                        </CardContent>
                        <Button
                          component={Link}
                          to="/researchpapers"
                          variant="outlined"
                          className={classes.learnButton}
                          onClick={() => {
                            props.setValue(1);
                            props.setSelectedIndex(1);
                          }}
                        >
                          <span style={{ marginRight: 10 }}>Learn More</span>
                          <ButtonArrow
                            width={10}
                            height={10}
                            fill={theme.palette.common.blue}
                          />
                        </Button>
                      </Card>
                    ))}
                  </Carousel>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid item>
        {/*-----Tech Flame-----*/}
        <Grid
          container
          style={{ height: "80em" }}
          alignItems="center"
          justifyContent="center"
        >
          <Card className={classes.revolutionCard}>
            <CardContent>
              <Grid
                container
                direction="column"
                style={{ textAlign: "center" }}
              >
                <Grid item>
                  <Typography variant="h3" gutterBottom>
                    Tech Flame
                  </Typography>
                </Grid>
                <Grid item>
                  <Carousel>
                    {techflames.map((project, i) => (
                      <Card sx={{ maxWidth: 480 }}>
                        <CardHeader title={project.title} />
                        <CardMedia
                          component="img"
                          height="194"
                          width="194"
                          image={project.image}
                          alt={project.title}
                        />
                        <CardContent>
                          <Typography variant="body2" color="text.secondary">
                            {project.description}
                          </Typography>
                        </CardContent>
                        <Button
                          component={Link}
                          to="/projects"
                          variant="outlined"
                          className={classes.learnButton}
                          onClick={() => {
                            props.setValue(1);
                            props.setSelectedIndex(1);
                          }}
                        >
                          <span style={{ marginRight: 10 }}>Learn More</span>
                          <ButtonArrow
                            width={10}
                            height={10}
                            fill={theme.palette.common.blue}
                          />
                        </Button>
                      </Card>
                    ))}
                  </Carousel>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid item>
        {/*-----Information Block-----*/}
        <Grid
          container
          style={{ height: "60em" }}
          alignItems="center"
          direction="row"
          className={classes.infoBackground}
        >
          <Grid
            item
            container
            style={{
              textAlign: matchesXS ? "center" : "inherit",
            }}
            direction={matchesXS ? "column" : "row"}
          >
            <Grid
              item
              sm
              style={{ marginLeft: matchesXS ? 0 : matchesSM ? "2em" : "5em" }}
            >
              <Grid
                container
                style={{ marginBottom: matchesXS ? "10em" : 0 }}
                direction="column"
              >
                <Typography variant="h2" style={{ color: "white" }}>
                  About Us
                </Typography>
                <Typography variant="subtitle2">Let's get personal.</Typography>
                <Grid item>
                  <Button
                    component={Link}
                    to="/about"
                    variant="outlined"
                    style={{ color: "white", borderColor: "white" }}
                    className={classes.learnButton}
                    onClick={() => props.setValue(3)}
                  >
                    <span style={{ marginRight: 10 }}>Learn More</span>
                    <ButtonArrow width={10} height={10} fill="white" />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              sm
              style={{
                marginRight: matchesXS ? 0 : matchesSM ? "2em" : "5em",
                textAlign: matchesXS ? "center" : "right",
              }}
            >
              <Grid container direction="column">
                <Typography variant="h2" style={{ color: "white" }}>
                  Contact Us
                </Typography>
                <Typography variant="subtitle2">
                  Say hello!{" "}
                  <span role="img" aria-label="waving hand">
                    👋🏻
                  </span>
                </Typography>
                <Grid item>
                  <Button
                    component={Link}
                    to="/contact"
                    variant="outlined"
                    style={{ color: "white", borderColor: "white" }}
                    className={classes.learnButton}
                    onClick={() => props.setValue(4)}
                  >
                    <span style={{ marginRight: 10 }}>Learn More</span>
                    <ButtonArrow width={10} height={10} fill="white" />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {/*-----Call To Action Block-----*/}
        <CallToAction setValue={props.setValue} />
      </Grid>
    </Grid>
  );
}
